module.exports = __webpack_public_path__ + "static/media/slider-handle.bd20ac9a.svg";